import React from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import { ListGroupItem } from 'reactstrap';
import icnDelete from './delete.svg';
import icnMenu from './menu.svg';
import './style.css';

const SortableItem = SortableElement(({ item, onDelete }) => {
  if (item.isGroup) {
    return (
      <ListGroupItem className="list-group-item-warning">
        <div className="row">
          <div className="col-md-2">
            <a onClick={onDelete}>
              <img src={icnDelete} alt="delete group" className="icon" />
            </a>
          </div>
          <div className="col-md-10">
            {item.name}
            <DragHandle />
          </div>
        </div>
      </ListGroupItem>
    );
  }
  return (
    <ListGroupItem>
      <div className="row">
        <div className="col-md-2">
          <a onClick={onDelete}>
            <img src={icnDelete} alt="delete item" className="icon" />
          </a>
        </div>

        <div className="col-md-7">{item.name}</div>
        <div className="col-md-3">
          <b>{`${item.price || ''}`}</b>
          <DragHandle />
        </div>
      </div>
    </ListGroupItem>
  );
});

const DragHandle = SortableHandle(() => (
  <div className="dragHandle">
    <img src={icnMenu} alt="drag" className="icon" />
  </div>
));

export default SortableItem;



// WEBPACK FOOTER //
// ./src/modules/Pricing/PriceList/SortableItem.js